import React from "react";
import ExportHistorySearchForm from "./ExportHistorySearchForm";

const ExportHistoryControlPanel = () => (
  <div id="sidebar" className="sidebar-search full-height alt-style">
    <div className="sidebar-search-container">
      <div className="sidebar-scroll-fade-top"></div>
      <div className="sidebar-search-wrapper">
        <div className="sidebar-search-content">
          <ExportHistorySearchForm />
        </div>
      </div>
    </div>
  </div>
);

export default ExportHistoryControlPanel;
